<div class="rounded-4 border border-warning border-opacity-25 bg-dark bg-opacity-25 p-3 text-center">
    <div class="text-uppercase text-white-50 small fw-semibold">
      {{ title }}
    </div>

    <div class="text-warning fw-bold fs-4 lh-1 mt-1">
      {{ value }}
    </div>

    <div class="text-success small fw-semibold mt-2 d-flex align-items-center justify-content-center gap-1">
      <i class="bi bi-arrow-down"></i>
      <span>{{ subtext }}</span>
    </div>
</div>
